export enum PlatformType {
  Fixed = 'Fixed',
  Tote = 'Tote',
}
